import classnames from "classnames/bind";
import Config from "config";
import React, { createRef, useEffect, useState } from "react";

const $ = window.$;
export class SelectList extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.className) {
      this.className = this.props.className;
    } else {
      this.className = "select-field mb-3";
    }

    this.minimumResultsForSearch = this.props.minimumResultsForSearch;

    // console.log("select name",this.className)
    this.handleChange = this.handleChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    // this.props.OnformsDataChange({
    //   field: e,
    //   value: e.params.args.data.id,
    // });
    this.props.OnformsDataChange(e);
    this.$el.select2("close");
  }

  handleOpen() {
    console.log("this.props.placeholderSearch", this.props.placeholderSearch);
    $("input.select2-search__field").prop("placeholder", this.props.placeholderSearch);
  }

  componentDidMount() {
    //const props = this.props
    this.$el = $(this.el);

    if (this.$el.data("select2")) {
      this.$el.select2("destroy");
    }

    this.select2Setting = {
      placeholder: this.props.placeholder,
      allowClear: true,
      //onChange: this.handleChange
    };

    if (this.props.dropdownParent) {
      this.select2Setting.dropdownParent = $(this.props.dropdownParent);
    }

    if (this.props.minimumResultsForSearch) {
      this.select2Setting.minimumResultsForSearch = this.props.minimumResultsForSearch;
    }

    // console.log(this.select2Setting)
    this.$el
      .select2(this.select2Setting)
      .one("select2:open", this.handleOpen)
      .on("select2:select", this.handleChange);
  }

  componentDidUpdate(prevProps) {
    
    if (JSON.stringify(prevProps.option) !== JSON.stringify(this.props.option)) {
      if (this.$el.data("select2")) {
        this.$el.select2("destroy");
      }

      if (!showSelectList(this.props.option, this.props.hideEmpty)) {
        this.$el.hide();
        return;
      }
      this.$el.show();

      this.$el
        .select2(
          this.select2Setting
          //     {
          //     placeholder: this.props.placeholder,
          //     allowClear: true,
          //     //onChange: this.handleChange
          // }
        )
        .one("select2:open", this.handleOpen)
        .on("select2:select", this.handleChange);
      // console.log(`SelectList ${this.props.fieldName} Updated`)
    }
    if (prevProps.value !== this.props.value) {
      this.$el.trigger("change.select2");
    }
  }

  render() {
    return (
      <select
        className={this.className}
        name={this.props.id}
        id={this.props.id}
        value={this.props.value}
        ref={(el) => (this.el = el)}
        readOnly
      >
        {!this.props.notShowEmptyOption && <option value="ทั้งหมด">ทั้งหมด</option>}
        {Array.isArray(this.props.option) &&
          this.props.option.map((item, index) => renderChild(item, index))}
      </select>
    );
  }
}

function showSelectList(option, hideEmpty) {
  if (!hideEmpty) {
    return true;
  } else if (Array.isArray(option) && option.length > 0) {
    return true;
  }
  return false;
}

function renderChild(item, index) {
  return (
    <option key={item.value} value={item.value} title={item.title}>
      {item.text}
    </option>
  );
}
